import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const mapSrc =
    'https://maps.google.com/maps?q=AALITECH%2C+4th+Ln%2C+Syamala+Nagar%2C+Guntur%2C+Andhra+Pradesh+522006&output=embed&z=16&hl=en';

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">

          {/* Column 1: Brand Profile */}
          <div className="footer-col brand-col">
            <Link to="/" className="footer-logo-link">
              <img src="/assets/opt/company-logo.webp" alt="AALI Group Logo" />
              <span className="logo-text">AALI GROUP</span>
            </Link>
            <p className="footer-description">
              Building excellence across industries. A diversified conglomerate committed to innovation, quality, and social responsibility.
            </p>
            {/* Instagram/Facebook open AALI CONSSULTANCY for now; YouTube and Twitter have no profile yet (no link) */}
            <div className="social-icons">
              <a href="https://www.instagram.com/aaliconssultancy/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="AALI CONSSULTANCY on Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61585917585366" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="AALI CONSSULTANCY on Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a className="social-icon" aria-hidden="true" style={{ cursor: 'default' }}>
                <i className="fab fa-youtube"></i>
              </a>
              <a className="social-icon" aria-hidden="true" style={{ cursor: 'default' }}>
                <i className="fab fa-twitter"></i>
              </a>
            </div>

            {/* Group companies that have their own website */}
            <div className="footer-companies">
              <h4 className="footer-heading">Our Companies</h4>
              <ul className="footer-links">
                <li><a href="https://aalitech.co/" target="_blank" rel="noopener">AALITECH</a></li>
                <li><a href="https://aaliconssultancy.com/" target="_blank" rel="noopener">AALI CONSSULTANCY</a></li>
                <li><a href="https://aalibuilders.com/" target="_blank" rel="noopener">AALI BUILDERS</a></li>
              </ul>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-col">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><NavLink to="/about" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>About Us</NavLink></li>
              <li><NavLink to="/businesses" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Our Businesses</NavLink></li>
              <li><NavLink to="/investors" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Investors</NavLink></li>
              <li><NavLink to="/newsroom" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Newsroom</NavLink></li>
              <li><NavLink to="/careers" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Careers</NavLink></li>
              <li><NavLink to="/contact" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Contact Us</NavLink></li>
              <li><NavLink to="/global-locations" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Global Locations</NavLink></li>
            </ul>
          </div>

          {/* Column 3: Industries */}
          <div className="footer-col">
            <h4 className="footer-heading">Our Industries</h4>
            <ul className="footer-links">
              <li><NavLink to="/industries/tech-cons" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Technology & Consulting</NavLink></li>
              <li><NavLink to="/industries/builders-dev" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Infrastructure & Development</NavLink></li>
              <li><NavLink to="/industries/media-entertainment" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Media & Entertainment</NavLink></li>
              <li><NavLink to="/industries/luxury-retail" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Luxury & Retail</NavLink></li>
              <li><NavLink to="/industries/social-impact" className={({ isActive }) => isActive ? 'active-footer-link' : ''}>Social Impact</NavLink></li>
            </ul>
          </div>

          {/* Column 4: Contact details */}
          <div className="footer-col">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
                <span>AALITECH, 4th Ln, Syamala Nagar, Guntur, Andhra Pradesh 522006</span>
              </div>
              {/* mobiles get a mobile-phone icon, the office landline a telephone handset */}
              <div className="contact-item">
                <i className="fas fa-mobile-screen-button" aria-hidden="true"></i>
                <a href="tel:+918341085415">+91 83410 85415</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-mobile-screen-button" aria-hidden="true"></i>
                <a href="tel:+917075893515">+91 70758 93515</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone" aria-hidden="true"></i>
                <a href="tel:+918634611770">+91 863 461 1770</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope" aria-hidden="true"></i>
                <a href="mailto:info@aaligroup.co">info@aaligroup.co</a>
              </div>
            </div>

            {/* ── Google Map Embed ── */}
            <div className="footer-map-wrapper">
              <iframe
                title="AALITECH Office Location"
                src={mapSrc}
                className="footer-map-iframe"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

        </div>
      </div>

      {/* Copyright Bar */}
      <div className="copyright-bar">
        <div className="footer-container">
          <p>© {currentYear} AALI GROUP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;